import { withStyles, WithStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import InfoIcon from '@material-ui/icons/Info'
import classNames from 'classnames'
import React from 'react'

import CardHeader from './CardHeader'

const styles = () =>
  createStyles({
    root: {
      borderTopLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      flex: 1,
      minHeight: 60,
      padding: 30,
    },
    title: {
      fontSize: 26,
      fontWeight: 'bold',
      color: '#192233',
      marginBottom: 24,
      display: 'flex',
      alignItems: 'center',
    },
    ico: {
      fontSize: 20,
      marginLeft: 15,
      color: '#BCBCBC',
    },
    toolTipLabel: {
      fontSize: 15,
    },
  })

interface ICardSectionProps extends WithStyles<typeof styles> {
  children?: React.ReactNode
  className?: string
  info?: string
  title: string
  titleClassName?: string
}

function CardSection(props: ICardSectionProps) {
  const { classes, className, title, info, children } = props

  return (
    <CardHeader className={classNames(classes.root, className)}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Typography className={classes.title}>
          {title}
          {info && (
            <Tooltip disableFocusListener={true} title={info} classes={{ tooltip: classes.toolTipLabel }}>
              <InfoIcon className={classes.ico} />
            </Tooltip>
          )}
        </Typography>
      </div>
      {children}
    </CardHeader>
  )
}

export default withStyles(styles)(CardSection)
